/**
 * @generated SignedSource<<6c0a91e745996f53732022a7307f6d7d>>
 * @relayHash a6218fab775f20b2d64f2488618a1ee0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type ShortcutsPopupContentQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
};
export type ShortcutsPopupContentQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly key: string;
    readonly projectId: string;
    readonly projectType: JiraProjectType;
  };
};
export type ShortcutsPopupContentQuery = {
  response: ShortcutsPopupContentQuery$data;
  variables: ShortcutsPopupContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "key"
},
v3 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v4 = {
  "kind": "ScalarField",
  "name": "projectId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ShortcutsPopupContentQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW",
              "path": "jira_projectByIdOrKey.key"
            },
            {
              "kind": "RequiredField",
              "field": (v3/*: any*/),
              "action": "THROW",
              "path": "jira_projectByIdOrKey.projectType"
            },
            {
              "kind": "RequiredField",
              "field": (v4/*: any*/),
              "action": "THROW",
              "path": "jira_projectByIdOrKey.projectId"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectByIdOrKey"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ShortcutsPopupContentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bbd38f006fb6a30be026af75e9185b1301cc9753e91e5f4bd37871d8143f0bc6",
    "metadata": {},
    "name": "ShortcutsPopupContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6fa8881cba653e7f2ddc0665b57f7b00";

export default node;
